import { createWithEqualityFn } from "zustand/traditional";
import { devtools } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { LoyaltyTabs } from "constants/loyalty";

interface IUseLoyaltyStore {
  isOpenOnboarding: boolean; // Флаг об открытии главного онбординга
  setIsOpenOnboarding: (isOpenOnboarding: boolean) => void;
  indexActiveRank: number;
  setIndexActiveRank: (index: number) => void;
  contextOnboardingOpen: boolean; // Флаг об открытии контекстного онбординга
  setContextOnboarding: (isOpen: boolean) => void;
  onboardingWatch: boolean; // Флаг о просмотре онбординга сейчас
  setOnboardingWatch: (isOnboardingWatch: boolean) => void;
  locationLoyalty: LoyaltyTabs;
  setLocationLoyalty: (location: LoyaltyTabs) => void;
  onboardingBoosterIsOpen: boolean;
  setOnboardingBooster: (isOpen: boolean) => void;
  onboardingRollbackIsOpen: boolean;
  setOnboardingRollback: (isOpen: boolean) => void;
}

export const useLoyaltyStore = createWithEqualityFn<IUseLoyaltyStore>()(
  devtools(
    (set) => ({
      isOpenOnboarding: false,
      indexActiveRank: 0,
      contextOnboardingOpen: false,
      onboardingWatch: false,
      onboardingBoosterIsOpen: false,
      onboardingRollbackIsOpen: false,
      locationLoyalty: LoyaltyTabs.REWARDS,
      setIsOpenOnboarding: (isOpenOnboarding) => {
        set({ isOpenOnboarding });
      },
      setIndexActiveRank: (index: number) => {
        set({ indexActiveRank: index });
      },
      setContextOnboarding: (isOpen: boolean) => {
        set({ contextOnboardingOpen: isOpen });
      },
      setOnboardingWatch: (watch) => {
        set({ onboardingWatch: watch });
      },
      setLocationLoyalty: (location: LoyaltyTabs) => {
        set({ locationLoyalty: location });
      },
      setOnboardingBooster: (isOpen: boolean) => {
        set({ onboardingBoosterIsOpen: isOpen });
      },
      setOnboardingRollback: (isOpen: boolean) => {
        set({ onboardingRollbackIsOpen: isOpen });
      },
    }),
    { name: "LoyaltyStore" },
  ),
  shallow,
);
